"use client";
import React from "react";

import AccountLayout from "../layout/AccountLayout";
import { RiWalletLine } from "@remixicon/react";

const MyOrderPage = () => {
  return (
    <>
      <AccountLayout>
        <h2>Đơn hàng</h2>
        <div className=" rounded-3xl p-6 shadow-lg mb-4 background-wallet">
          <button className="w-[50%] border m-auto block border-blue-400 text-rose-400 py-3 rounded-xl hover:bg-blue-50 bg-white transition mb-4">
            + Nạp tiền vào ví
          </button>
          <div className="flex justify-between items-start mb-6">
            <div className="flex items-center gap-4">
              <div className="text-blue-400">
                <RiWalletLine size={48} />
              </div>
              <div>
                <p className="text-lg font-medium ">Số dư</p>
                <h1 className="text-4xl font-bold">0 đ</h1>
              </div>
            </div>
          </div>
        </div>
      </AccountLayout>
    </>
  );
};

export default MyOrderPage;
